import { useMgPrisConfig } from '@retail/app/stores/app-config';
import { useAuthContext } from '@retail/auth/data-access';
import { useMutateMPEFetch } from '@retail/app/hooks';
import { buildUrl } from '@shared/utils';
import { mpeApi } from '@retail/mgpris/config';
import { QueryOptions } from '@shared/fetch-utils';
import { SupplierNotificationConfigDTO } from '@retail/suppliers/types';

interface PurchaseAgreementPriceDTO {
  mgItemNumber?: number;
  finfoNumber?: number;
  nobbNumber?: number;
  price: number;
  validFrom: string;
  validTo?: string;
  gtinCode?: number;
}

interface Props {
  supplierNumber: number;
  localAgreement: boolean;
}

export function usePostPurchaseAgreements({ localAgreement, supplierNumber }: Props) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMutateMPEFetch<undefined, PurchaseAgreementPriceDTO[], number>({
    token,
    method: 'POST',
    url: () =>
      buildUrl({
        base: mpe.url,
        route: mpeApi.suppliers.supplier.agreementPrices.getFullLinkPath({
          supplierId: supplierNumber,
        }),
        searchParams: { localAgreement },
      }),
  });
}

export interface PatchSupplierConfigBody {
  notificationConfig?: SupplierNotificationConfigDTO[];
}

export function useMutateSupplierConfig({
  assortmentId,
  ...queryOptions
}: {
  assortmentId: number;
} & Partial<QueryOptions>) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMutateMPEFetch<undefined, PatchSupplierConfigBody, number>({
    token,
    method: 'PATCH',
    url: (supplierId) =>
      buildUrl({
        base: mpe.url,
        route: mpeApi.suppliers.supplier.configuration.getFullLinkPath({
          supplierId,
        }),
        searchParams: { assortmentId },
      }),
    ...queryOptions,
  });
}
